import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
	setSelectedAdditionalDataModal,
	setAdditionalModal,
	resetTotalAdditional,
	resetCommissionAdditional,
	setCommissionsAdditionalType,
} from '../Reports/reports.slice'
import Modal, { showModal } from '../../widgets/modal'
import Table from '../../widgets/Table'
import {
	selectTotalsAdditional,
	selectCommissionsAdditional,
	selectAdditionalModal,
	selectCommissionsAdditionalType,
	selectFilters,
} from '../Reports/reports.selectors'
import BusyIndicator, { REGIONS } from '../../widgets/busyIndicator'
import {
	COMMISSION_COLUMNS,
	CommissionsTableRowClassFormatter,
} from '../Reports/reports.constants'
import { Button } from '@/components/ui/button'
import Icons from '../../assets/icons'
import { exportCommissionReport } from '../Reports/reports.asynActions'

const COMMISSION = 'Billing'

const AdditionalDataModal = ({ column }) => {
	const dispatch = useDispatch()
	const resetModal = () => {
		dispatch(setSelectedAdditionalDataModal(null))
		dispatch(setAdditionalModal(null))
		dispatch(resetTotalAdditional())
		dispatch(resetCommissionAdditional())
		dispatch(setCommissionsAdditionalType(null))
	}
	const commissionsAdditionalType = useSelector(selectCommissionsAdditionalType)
	const totalsAdditional = useSelector(selectTotalsAdditional)
	const commissionsAdditional = useSelector(selectCommissionsAdditional)
	const additionalModal = useSelector(selectAdditionalModal)
	const filters = useSelector(selectFilters)
	const [isExporting, setIsExporting] = useState(false)

	useEffect(() => {
		dispatch(showModal())
	}, [dispatch])

	const rowClasses =
		column === COMMISSION_COLUMNS.COMMISSION_DETAILS
			? CommissionsTableRowClassFormatter
			: 'text-table-data'

	const expandRow =
		additionalModal === COMMISSION
			&& {
					// eslint-disable-next-line
					renderer: (row, rowIndex) => {
						return (
							<div key={rowIndex}>
								<Table
									keyField='crmDealId'
									data={[commissionsAdditional[rowIndex]]}
									columns={COMMISSION_COLUMNS.COMMISSION_DEAL_LINKS}
									innerTable={true}
									region={REGIONS.FETCH_COMMISSION_ADDITIONALS}
									isDisplayTable={true}
								/>
							</div>
						)
					},
					onlyOneExpanding: true,
					expandColumnPosition: 'right',
					// eslint-disable-next-line
					expandHeaderColumnRenderer: () => <div></div>,
					// eslint-disable-next-line
					expandColumnRenderer: ({ expanded, rowKey }) => (
						<div className='btn-auto p-0 d-inline-flex align-items-center f-5 pointer font-semi-bold align-left text-nowrap'>
							{expanded ? 'View Less' : 'View More'}
							{
								<img
									src={expanded ? Icons.ArrowUp : Icons.ArrowDown}
									width='15'
									className='ml-2'
									alt='arrow-icon'
								/>
							}
						</div>
					),
				}
	

	function HandleExportCommissionReport() {
		setIsExporting(true)
		dispatch(
			exportCommissionReport({
				filters: {
					...filters,
					commissionType: commissionsAdditionalType,
				},
			})
		).then(() => {
			setIsExporting(false)
		})
	}

	return (
		<Modal title='Additional Data' reset={resetModal}>
			{commissionsAdditionalType && (
				<Button
					disabled={isExporting}
					onClick={() => {
						HandleExportCommissionReport()
					}}
				>
					<BusyIndicator region={REGIONS.EXPORT_COMMISSION_REPORT}>
						Export
					</BusyIndicator>
				</Button>
			)}
			<div className=' w-full max-w-full overflow-x-auto'>
				<Table
					keyField='id'
					columns={column}
					data={
						additionalModal === COMMISSION
							? commissionsAdditional.map((com, index) => {
									return { ...com, id: index }
								})
							: totalsAdditional
						}
					region={
						additionalModal === COMMISSION
							? REGIONS.FETCH_COMMISSION_ADDITIONALS
							: REGIONS.FETCH_TOTAL_ADDITIONALS
					}
					isDisplayTable={true}
					rowClasses={rowClasses}
					expandRow={expandRow}
				/>
			</div>
		</Modal>
	)
}
export default AdditionalDataModal
